<template>
  <div data-cy="logged-user">
    <span>{{ loggedUser.username }} </span>
    <a href="/" @click="logoutUser">Wyloguj</a>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'LoggedUser',
  computed: {
    ...mapState(['loggedUser']),
  },
  methods: {
    ...mapActions(['logoutUser']),
  },
}
</script>
